import { IndexContainer, IndexHeader, CardGrid, IndexCard } from '../../../styles/global'

export function ConcreteIndex() {
  const gradient = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  const accentColor = '#667eea'

  const calculators = [
    {
      title: 'Flexão',
      description: 'Dimensionamento de vigas e lajes submetidas à flexão simples',
      path: '/concreto/flexao',
      icon: '📐',
      popular: true,
    },
    {
      title: 'Flexo-Tração',
      description: 'Dimensionamento de seções em flexão composta com tração',
      path: '/concreto/flexo-tracao',
      icon: '📐',
      popular: false,
    },
    {
      title: 'Flexo-Compressão Oblíqua',
      description: 'Verificação de seções submetidas a força normal e momentos fletores em dois eixos',
      path: '/concreto/flexo-compressao-obliqua',
      icon: '📐',
      popular: false,
    },
    {
      title: 'Cisalhamento',
      description: 'Verificação e dimensionamento de elementos ao esforço cortante',
      path: '/concreto/cisalhamento',
      icon: '✂️',
      popular: true,
    },
    {
      title: 'Escada',
      description: 'Dimensionamento de escadas com patamar intermediário',
      path: '/concreto/escada-longitudinal-patamar',
      icon: '📉',
      popular: true,
    },
    {
      title: 'Torção',
      description: 'Análise de elementos estruturais submetidos à torção',
      path: '/concreto/torcao',
      icon: '🔄',
      popular: false,
    },
    {
      title: 'Inércia Equivalente',
      description: 'Cálculo da inércia equivalente pelo método de Branson',
      path: '/concreto/inercia-equivalente',
      icon: '📊',
      popular: false,
    },
    {
      title: 'Fadiga da Armadura',
      description: 'Verificação da fadiga da armadura longitudinal em seções de concreto armado',
      path: '/concreto/fadiga-armadura-longitudinal',
      icon: '🔁',
      popular: false,
    },
    {
      title: 'Fadiga da Armadura Transversal',
      description: 'Verificação da fadiga dos estribos em seções retangulares de concreto armado',
      path: '/concreto/fadiga-armadura-transversal',
      icon: '🔃',
      popular: false,
    },
    {
      title: 'Consolo',
      description: 'Dimensionamento e verificação de consolos curtos',
      path: '/concreto/consolo',
      icon: '🔨',
      popular: false,
    },
    {
      title: 'Fundação sob Paredes',
      description: 'Dimensionamento de fundações corridas para paredes',
      path: '/concreto/fundacao-parede',
      icon: '🏗️',
      popular: false,
    },
    {
      title: 'Sapata Isolada',
      description: 'Dimensionamento de sapatas isoladas com carga centrada ou excêntrica',
      path: '/concreto/sapata-isolada',
      icon: '🧱',
      popular: false,
    },
    {
      title: 'Momento por Área',
      description: 'Cálculo do momento resistente a partir da área de aço existente',
      path: '/concreto/momento-area',
      icon: '📏',
      popular: false,
    },
    {
      title: 'Ancoragem',
      description: 'Verificação de ancoragem de barras no apoio e dimensionamento de grampo complementar',
      path: '/concreto/ancoragem',
      icon: '⚓',
      popular: false,
    },
    {
      title: 'Camada de Armadura',
      description: 'Quantidade máxima de barras longitudinais em uma única camada de uma viga',
      path: '/concreto/camada-armadura',
      icon: '🔩',
      popular: false,
    },
    {
      title: 'Pórtico 2D',
      description: 'Análise matricial de pórticos planos: deslocamentos, reações e esforços internos',
      path: '/concreto/portico-2d',
      icon: '🧮',
      popular: false,
    },
  ]

  return (
    <IndexContainer>
      <IndexHeader $gradient={gradient}>
        <div className="header-content">
          <h1>🏗️ Concreto Armado</h1>
          <p className="subtitle">
            Ferramentas completas para dimensionamento e verificação de elementos estruturais em concreto armado
          </p>
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number">{calculators.length}</span>
              <span className="stat-label">Calculadoras</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{calculators.filter((c) => c.popular).length}</span>
              <span className="stat-label">Mais Usadas</span>
            </div>
          </div>
        </div>
      </IndexHeader>

      <div className="content-wrapper">
        <h2>Calculadoras Disponíveis</h2>
        <CardGrid>
          {calculators.map((calc, index) => (
            <IndexCard
              key={index}
              to={calc.path}
              $popular={calc.popular}
              $gradient={gradient}
              $accentColor={accentColor}
            >
              {calc.popular && <span className="popular-badge">Popular</span>}
              <span className="card-icon">{calc.icon}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </IndexCard>
          ))}
        </CardGrid>
      </div>
    </IndexContainer>
  )
}
